import { BodyText } from '@utilitywarehouse/hearth-react';

export const declarationFields = [
  {
    key: 'age',
    testId: 'ageDeclaration',
    label: (
      <BodyText>
        You are over 18 and under 76 years of age, and a permanent resident of
        the UK.
      </BodyText>
    ),
  },
  {
    key: 'existingCondition',
    testId: 'existingCondition',
    label: (
      <BodyText>
        You understand that a pre-existing medical condition or notice of
        unemployment (i.e. one known at the time the policy starts) is excluded
        from this cover.
      </BodyText>
    ),
  },
  {
    key: 'working',
    testId: 'workingChecked',
    label: (
      <BodyText>
        You are working at least 16 hours a week in the UK on a contract that is
        either permanent or a minimum of 6 months. You are not currently absent
        from work due to illness or injury, other than minor illness such as
        cold or flu.
      </BodyText>
    ),
  },
  {
    key: 'myself',
    testId: 'myselfChecked',
    label: (
      <BodyText>
        I confirm that I have made the decision to add this cover myself based
        solely on my own consideration of the information provided to me on
        screen.
      </BodyText>
    ),
  },
];
